var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, observe, action, computed } from "mobx";
import { DeviceDetect } from "sb-resp-utils";
export class LeagueListPresenterState {
    constructor(provider, options) {
        this.provider = provider;
        this.leagues = this.provider.leagues.slice();
        this.selectedLeagues = this.provider.selectedLeagues.slice();
        this.options = options;
        this.numberOfTopLeaguesShown = this.options.cms.numberOfTopLeagues;
        this.numberOfAllLeaguesShownByDefault = this.options.cms.numberOfAllLeaguesShownByDefault;
        this.shouldShowAllLeagues = false;
        this.disposerLeagues = () => { };
        this.disposerSelected = () => { };
        this.disposerIsLoading = () => { };
        this.toggleSelectedLeague = this.toggleSelectedLeague.bind(this);
        this.openLeagueTranspiler = this.openLeagueTranspiler.bind(this);
        this.openCouponTranspiler = this.openCouponTranspiler.bind(this);
        this.sportId = "0";
        this.isDataLoaded = false;
        this.showAllButton = {
            label: this.options.dict.ShowAll,
            expanded: false
        };
        this.selectedLeaguesLimitReached = false;
        this.currentlySelectedLeague = "";
        this.deviceDetect = DeviceDetect.getInstance();
    }
    activate() {
        this.attachObservables();
        this.provider.activate();
    }
    /* istanbul ignore next */
    openLeagueTranspiler(sportId, leagueId, ev, element) {
        ev && ev.stopPropagation();
        ev && ev.preventDefault();
        this.options.navHandler.OpenLeague(ev, leagueId, sportId, element);
    }
    /* istanbul ignore next */
    openCouponTranspiler(sportId, ev) {
        ev && ev.stopPropagation();
        ev && ev.preventDefault();
        this.options.navHandler.OpenCoupon(sportId, this.selectedLeagues.slice());
    }
    deactivate() {
        this.provider.deactivate();
        this.detachObservable();
        this.clearData();
    }
    detachObservable() {
        this.disposerLeagues();
        this.disposerSelected();
        this.disposerIsLoading();
    }
    setParams(sportId, leagueIds) {
        this.provider.selectRetriever(sportId, leagueIds);
        this.sportId = sportId;
    }
    get getLeaguesToProcess() {
        return this.leagues.slice(0);
    }
    get getNumberOfAllLeaguesToRender() {
        return this.shouldShowAllLeagues
            ? this.leagues.length
            : this.numberOfAllLeaguesShownByDefault;
    }
    get showBottomButton() {
        return this.shouldShowAllLeagues && this.selectedLeagues.length !== 0 &&
            this.options.cms.showCouponButtonBottom;
    }
    /* istanbul ignore next */
    attachObservables() {
        /* istanbul ignore next */
        this.disposerLeagues = observe(this.provider, (change) => {
            this.updateLeagues(change);
        });
        this.disposerIsLoading = observe(this.provider, (change) => {
            this.isDataLoaded = !change.object.isLoading;
        });
        this.disposerSelected = observe(this.provider, (change) => {
            this.updateSelectedLeagues(change);
        });
    }
    /* istanbul ignore next */
    updateLeagues(change) {
        this.leagues = change.object.leagues;
    }
    /* istanbul ignore next */
    updateSelectedLeagues(change) {
        this.selectedLeagues = change.object.selectedLeagues;
    }
    /* istanbul ignore next */
    toggleSelectedLeague(leagueId) {
        this.selectedLeaguesLimitReached = !this.provider.toggleSelectedLeague(leagueId);
        this.currentlySelectedLeague = leagueId;
        this.selectedLeaguesLimitReached && setTimeout(() => {
            this.selectedLeaguesLimitReached = false;
        }, 5000);
    }
    /* istanbul ignore next */
    clearData() {
        this.leagues = observable([]);
    }
    /* istanbul ignore next */
    get onlyTopLeagues() {
        return this.provider.getTopLeaguesOnly;
    }
    onlyShownTopLeagues() {
        return this.onlyTopLeagues.slice(0, this.numberOfTopLeaguesShown);
    }
    onlyShowLeagues() {
        return this.leagues.slice(0, this.getNumberOfAllLeaguesToRender);
    }
    /* istanbul ignore next */
    showAllButtonHandler() {
        this.shouldShowAllLeagues = !this.shouldShowAllLeagues;
        this.showAllButton.expanded = !this.showAllButton.expanded;
        this.showAllButton.label = this.showAllButton.expanded ? this.options.dict.HideAll : this.options.dict.ShowAll;
    }
}
__decorate([
    observable,
    __metadata("design:type", Boolean)
], LeagueListPresenterState.prototype, "shouldShowAllLeagues", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], LeagueListPresenterState.prototype, "leagues", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], LeagueListPresenterState.prototype, "selectedLeagues", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], LeagueListPresenterState.prototype, "isDataLoaded", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LeagueListPresenterState.prototype, "showAllButton", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], LeagueListPresenterState.prototype, "selectedLeaguesLimitReached", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], LeagueListPresenterState.prototype, "currentlySelectedLeague", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], LeagueListPresenterState.prototype, "getLeaguesToProcess", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], LeagueListPresenterState.prototype, "getNumberOfAllLeaguesToRender", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], LeagueListPresenterState.prototype, "showBottomButton", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LeagueListPresenterState.prototype, "updateLeagues", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LeagueListPresenterState.prototype, "updateSelectedLeagues", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LeagueListPresenterState.prototype, "toggleSelectedLeague", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LeagueListPresenterState.prototype, "clearData", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], LeagueListPresenterState.prototype, "onlyTopLeagues", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LeagueListPresenterState.prototype, "showAllButtonHandler", null);
//# sourceMappingURL=LeagueListPresenterState.js.map